<template>
  <nav class="navbar">
    <div class="navbar-brand">
      <a class="navbar-item is-logo" href="#">
        <img src="/static/img/_logo.png" alt="Biya Support" height="40">
      </a>
      <div class="navbar-burger burger" data-target="navMenubd-example" @click="toggleClass" v-bind:class="{ 'is-active': isActive }">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>

    <div id="navMenubd-example" class="navbar-menu" v-bind:class="{ 'is-active': isActive }">
      <!-- <a class="navbar-item is-white" href="/status">
        Status
      </a>
      <a class="navbar-item is-white" href="/dispense">
        Dispense
      </a> -->
      <a class="navbar-item is-white" href="/transactions">
        Transactions
      </a>
      <a class="navbar-item is-white" href="/users">
        Users
      </a>
      <a class="navbar-item is-white" href="/d/users">
        D Users
      </a>
      <a class="navbar-item is-white" href="/d/batches">
        Batches
      </a>
      <a class="navbar-item is-white" href="/d/payments">
        Payments
      </a>
      <a class="navbar-item is-white" href="/dispense">
        Dispense Electricity
      </a>
      <a class="navbar-item is-white is-hidden-desktop" @click="logout">
        Logout
      </a>
    </div>

    <div class="navbar-end is-hidden-mobile">
      <div class="navbar-item">
        <div class="field is-grouped">
          <p class="control">
            <a class="button btn" href="#" @click="logout">
              <span>Logout</span>
            </a>
          </p>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'hello',
  data() {
    return {
      isActive: false
    };
  },
  methods: {
    toggleClass() {
      this.isActive = !this.isActive;
    },
    logout() {
      localStorage.removeItem('biyadmin');
      this.$router.push({ path: '/' });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
  background: #07844c;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #07844c 5%, #0ac97b);
  background: linear-gradient(to right, #07844c 5%, #0ac97b);
  padding-left: 2em;
  padding-right: 2em;
}

.is-white {
  color: #fff;
}

.is-white:hover {
  color: #07844c;
}

.is-logo:hover {
  background-color: transparent;
  color: #0a0a0a;
}

.btn {
  font-size: 16px;
  background: #0ac97b;
  border-color: #fff;
  color: #fff;
  transition: 0.3s;
}

.btn:hover {
  background: #fff;
  color: #07844c;
}
</style>



// WEBPACK FOOTER //
// CustomHeader.vue?1b6d02f7